import React from "react";
import projects from "./projects";
import ProjectCard from "./ProjectCard";

const ProjectsSection = () => {
  return (
    <div
      id="projects-section"
      className="relative min-h-screen w-full flex flex-col lg:flex-row justify-center items-center lg:justify-end p-4"
    >
      <div className="absolute text-right text-white font-bold text-[19vw] sm:text-[15vw] md:text-[15vw] lg:text-[18vw] right-4 bottom-0 leading-[15vw] opacity-5 select-none pointer-events-none">
        APPLIED <br />
        LEARNING
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 max-w-[90vw] md:max-w-[80vw] lg:max-w-[64vw] mt-[10%] lg:mt-[5%] lg:mr-20 mx-auto">
        {projects.map((project_, index) => (
          <ProjectCard key={index} index={index} project={project_} />
        ))}
      </div>
    </div>
  );
};

export default ProjectsSection;
